{
  "common": {
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "apply": "Aplicar",
    "yes": "Sí",
    "no": "No",
    "loading": "Cargando...",
    "error": "Error",
    "retry": "Reintentar",
    "add": "Agregar"
  },
  "navigation": {
    "home": "Inicio",
    "favorites": "Favoritos",
    "search": "Buscar"
  },
  "jobs": {
    "noJobs": "No se encontraron trabajos",
    "loadMore": "Cargar más",
    "apply": "Aplicar",
    "save": "Guardar",
    "unsave": "Quitar"
  },
  "search": {
    "placeholder": "Buscar trabajos...",
    "filter": "Filtrar",
    "clear": "Limpiar",
    "open": "Buscar trabajos",
    "close": "Cerrar búsqueda"
  },
  "alerts": {
    "title": "Alertas de empleo",
    "subtitle": "Recibe una notificación cuando aparezcan vacantes que coincidan con tu búsqueda.",
    "placeholder": "Palabras clave (ej. react remoto senior)",
    "empty": "Sin alertas aún",
    "matchingNow": "{{count}} coinciden ahora"
  },
  "description": {
    "openUrlMessage": "Abrir URL para más información",
    "postedOn": "Publicado el",
    "applyViewDetails": "Aplicar / Ver detalles"
  },
  "error": {
    "title": "Algo salió mal",
    "description": "¡Lo sentimos, no se encontraron trabajos! Probablemente sea un error de servidor o red.",
    "tryAgain": "Intentar de nuevo"
  },
  "filter": {
    "refineJobs": "Refinar trabajos",
    "title": "Filtrar",
    "total": "total",
    "reset": "Restablecer",
    "filterByDate": "Filtrar por fecha",
    "byDate": "Por Fecha",
    "byApplied": "Por Aplicadas",
    "appliedOnlyOn": "Solo aplicadas: activado",
    "appliedOnlyOff": "Solo aplicadas: desactivado",
    "postedAfter": "Publicado después de",
    "filterByTags": "Filtrar por etiquetas",
    "byTag": "Por Etiqueta",
    "clearAllFavorites": "Borrar todos los favoritos",
    "applyFilters": "Aplicar filtros"
  },
  "share": {
    "message": "Aquí hay una gran oportunidad de trabajo remoto:\n* Posición: {{position}}\n* Empresa: {{company}}\n* URL: {{url}}",
    "title": "App de Trabajo Remoto - {{position}} @{{company}}",
    "subject": "Trabajo compartido desde App de Trabajo Remoto",
    "dialogTitle": "Compartir un trabajo remoto"
  },
  "datepicker": {
    "selectDate": "Seleccionar Fecha",
    "year": "Año",
    "month": "Mes",
    "previousMonth": "Mes anterior",
    "nextMonth": "Mes siguiente",
    "weekdays": [
      "Dom",
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb"
    ],
    "months": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ]
  },
  "tabs": {
    "allJobs": "Todos los Trabajos",
    "favorites": "Favoritos",
    "resumeBuilder": "Currículum",
    "applications": "Candidaturas",
    "profile": "Perfil"
  },
  "favorites": {
    "deleteAll": "Eliminar todos los Favoritos",
    "empty": "Aún no tienes favoritos. Toca el corazón en un empleo para guardarlo aquí."
  },
  "icons": {
    "jobActions": "Acciones del Trabajo",
    "addToFavorites": "Agregar a Favoritos",
    "removeFromFavorites": "Quitar de Favoritos",
    "share": "Compartir",
    "openUrl": "Abrir URL",
    "markApplied": "Marcar como Aplicado",
    "removeApplied": "Quitar Aplicado"
  },
  "job": {
    "applied": "Aplicado",
    "fit": "Afinidad {{score}}%"
  },
  "list": {
    "found": "encontrados"
  },
  "onboarding": {
    "tagline": "¡Descubre oportunidades remotas seleccionadas de todo el mundo!",
    "next": "Siguiente"
  },
  "tour": {
    "skip": "Omitir",
    "next": "Siguiente",
    "getStarted": "Empezar",
    "slides": {
      "welcome": {
        "title": "Te damos la bienvenida",
        "description": "Un recorrido rápido por las funciones principales para encontrar tu próximo trabajo remoto más rápido."
      },
      "search": {
        "title": "Busca y filtra ofertas",
        "description": "Busca por palabra clave y filtra los resultados por fecha, etiquetas o estado de postulación."
      },
      "favorites": {
        "title": "Favoritos y postulaciones",
        "description": "Toca el corazón para guardar ofertas y marca a las que ya te postulaste."
      },
      "tracker": {
        "title": "Sigue tus postulaciones",
        "description": "Marca empleos como postulados y sigue cada uno por etapas — entrevista, oferta — con notas y fechas."
      },
      "alerts": {
        "title": "Recibe alertas de nuevas coincidencias",
        "description": "Guarda una búsqueda y recibe una notificación cuando nuevos empleos remotos coincidan con tus palabras clave."
      },
      "resume": {
        "title": "Crea tu currículum",
        "description": "Crea un currículo profesional, expórtalo como PDF o DOCX y mira qué tan bien encaja cada empleo con tus habilidades."
      },
      "account": {
        "title": "Inicia sesión para sincronizar",
        "description": "Crea una cuenta gratis para respaldar tus currículos, postulaciones, favoritos y alertas en todos tus dispositivos."
      },
      "settings": {
        "title": "Temas e idiomas",
        "description": "Alterna entre modo claro y oscuro y elige entre 9 idiomas en los ajustes."
      }
    }
  },
  "theme": {
    "toggle": "Cambiar tema"
  },
  "settings": {
    "title": "Configuración",
    "theme": "Tema",
    "themeLight": "Claro",
    "themeDark": "Oscuro",
    "language": "Idioma",
    "open": "Abrir configuración",
    "close": "Cerrar",
    "developer": "Desarrollador",
    "hideAds": "Ocultar anuncios",
    "removeAds": {
      "title": "Eliminar anuncios",
      "buy": "Eliminar anuncios — {{price}}",
      "restore": "Restaurar compras",
      "purchased": "¡Gracias por apoyar RemoteWork! Los anuncios están desactivados.",
      "successTitle": "Anuncios eliminados",
      "successMessage": "¡Gracias por tu apoyo! Los anuncios ahora están desactivados en toda la app.",
      "errorTitle": "Error en la compra",
      "errorMessage": "Algo salió mal. Inténtalo de nuevo.",
      "restoreEmptyTitle": "Nada que restaurar",
      "restoreEmptyMessage": "No se encontró ninguna compra anterior en esta cuenta."
    },
    "tour": "Tour",
    "replayTour": "Repetir tour",
    "account": "Cuenta",
    "deleteAccount": {
      "action": "Eliminar cuenta",
      "confirmTitle": "¿Eliminar cuenta?",
      "confirmMessage": "Esto elimina permanentemente tu cuenta y todos los datos sincronizados: currículos, postulaciones, favoritos y alertas. No se puede deshacer.",
      "errorTitle": "No se pudo eliminar la cuenta",
      "errorMessage": "Algo salió mal. Inténtalo de nuevo.",
      "reauthMessage": "Por tu seguridad, cierra sesión y vuelve a iniciar sesión, luego intenta eliminar tu cuenta."
    },
    "about": "Acerca de",
    "privacyPolicy": "Política de privacidad",
    "website": "Visitar el sitio web"
  },
  "ad": {
    "sponsored": "Patrocinado"
  },
  "consent": {
    "message": "Usamos cookies de analítica para entender cómo se utiliza el sitio. Permanecen desactivadas hasta que aceptes.",
    "accept": "Aceptar",
    "reject": "Rechazar"
  },
  "disclaimer": {
    "title": "Acerca de las ofertas de empleo",
    "message": "Los empleos que se muestran en esta aplicación provienen de fuentes de terceros y APIs públicas. No publicamos, seleccionamos ni controlamos estos anuncios, y no podemos garantizar la exactitud, la calidad ni la disponibilidad de ninguna oferta. Confirma siempre los detalles directamente con el empleador antes de postularte.",
    "okCountdown": "Aceptar ({{seconds}})"
  },
  "resume": {
    "title": "Generador de currículums",
    "newResume": "Nuevo",
    "newResumePrompt": "Nombra tu currículum",
    "namePlaceholder": "Ej.: CV Frontend",
    "lastModified": "Última modificación",
    "discardTitle": "¿Descartar cambios?",
    "discardMessage": "Tienes cambios sin guardar.",
    "webPlaceholder": {
      "title": "El generador de currículums solo está disponible en móvil",
      "subtitle": "Abre la app en Android o iOS para crear y exportar tu currículum."
    },
    "actions": {
      "edit": "Editar",
      "duplicate": "Duplicar",
      "delete": "Eliminar",
      "more": "Más opciones",
      "deleteConfirmTitle": "¿Eliminar currículum?",
      "deleteConfirmMessage": "¿Eliminar definitivamente \"{{name}}\"? Esta acción no se puede deshacer."
    },
    "empty": {
      "title": "Aún no hay currículums",
      "subtitle": "Crea un currículum profesional y expórtalo como PDF o DOCX.",
      "cta": "Crear mi primer currículum",
      "skillsHint": "Agrega habilidades como JavaScript, diseño, liderazgo…"
    },
    "sections": {
      "personalInfo": "Información personal",
      "experience": "Experiencia",
      "education": "Educación",
      "skills": "Habilidades",
      "languages": "Idiomas",
      "links": "Enlaces",
      "template": "Plantilla",
      "contact": "Contacto",
      "summary": "Resumen",
      "personalization": "Personalización",
      "preview": "Vista previa"
    },
    "fields": {
      "fullName": "Nombre completo",
      "title": "Título profesional",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "location": "Ubicación",
      "website": "Sitio web",
      "summary": "Resumen profesional",
      "company": "Empresa",
      "position": "Puesto",
      "institution": "Institución",
      "degree": "Titulación",
      "field": "Área de estudio",
      "startDate": "Inicio",
      "endDate": "Fin",
      "current": "Trabajo actualmente aquí",
      "present": "Actualidad",
      "description": "Descripción",
      "skillPlaceholder": "Añadir habilidad",
      "languageName": "Idioma",
      "languageProficiency": "Nivel",
      "linkLabel": "Etiqueta",
      "linkUrl": "URL",
      "phoneCountryCode": "Código de país"
    },
    "proficiency": {
      "basic": "Básico",
      "conversational": "Conversacional",
      "fluent": "Fluido",
      "native": "Nativo"
    },
    "templates": {
      "modern": "Moderno",
      "classic": "Clásico",
      "minimal": "Minimalista",
      "modernDescription": "Diseño de dos columnas con barra lateral con color.",
      "classicDescription": "Tradicional en blanco y negro, columna única.",
      "minimalDescription": "Limpio, con mucho espacio en blanco y sin color."
    },
    "buttons": {
      "addExperience": "Añadir experiencia",
      "addEducation": "Añadir educación",
      "addLanguage": "Añadir idioma",
      "addLink": "Añadir enlace",
      "remove": "Eliminar",
      "save": "Guardar",
      "discard": "Descartar",
      "export": "Exportar",
      "exportPdf": "Exportar como PDF",
      "exportDocx": "Exportar como DOCX",
      "create": "Crear",
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "export": {
      "preparing": "Preparando el archivo…",
      "preparingHint": "Elige un formato. El archivo se abrirá en el menú de compartir.",
      "errorTitle": "Error de exportación",
      "errorMessage": "Algo salió mal al exportar tu currículum."
    },
    "validation": {
      "invalidEmail": "Introduce un correo electrónico válido.",
      "invalidCountryCode": "Hasta 4 dígitos, opcionalmente con + al inicio.",
      "invalidWebsite": "Introduce un sitio web válido (p. ej., ejemplo.com)."
    },
    "personalization": {
      "title": "Personalizar",
      "colorMode": "Tema de color",
      "modes": {
        "light": "Claro",
        "dark": "Oscuro"
      },
      "fontFamily": "Fuente",
      "fonts": {
        "sans": "Sans",
        "serif": "Serif",
        "modern": "Moderna",
        "mono": "Mono"
      },
      "fontSize": "Tamaño de fuente",
      "sizes": {
        "title": "Título",
        "subtitle": "Subtítulo",
        "body": "Cuerpo"
      },
      "increase": "Aumentar {{field}}",
      "decrease": "Reducir {{field}}"
    },
    "photo": {
      "placeholder": "Sin foto",
      "choose": "Agregar foto",
      "change": "Cambiar foto",
      "remove": "Quitar",
      "permissionTitle": "Permiso necesario",
      "permissionMessage": "Permite el acceso a la galería para elegir una foto de perfil."
    }
  },
  "sort": {
    "recent": "Más recientes",
    "bestFit": "Mejor afinidad",
    "toggle": "Ordenar por afinidad"
  },
  "applyKit": {
    "title": "Kit de postulación",
    "hint": "Toca para copiar y pegar en el formulario.",
    "copied": "Copiado",
    "openExternal": "Abrir en el navegador"
  },
  "applications": {
    "title": "Candidaturas",
    "empty": {
      "title": "Sin candidaturas aún",
      "subtitle": "Las vacantes a las que te postules aparecerán aquí para seguir su estado."
    },
    "status": {
      "applied": "Postulado",
      "interviewing": "Entrevista",
      "offer": "Oferta",
      "rejected": "Rechazado"
    },
    "notesPlaceholder": "Agregar notas…",
    "remove": "Quitar",
    "removeConfirm": "¿Quitar esta candidatura?",
    "lastUpdate": "Última actualización: {{date}}",
    "editDate": "Editar fecha",
    "addManual": "Agregar candidatura"
  },
  "auth": {
    "account": "Cuenta",
    "signIn": "Iniciar sesión",
    "signUp": "Crear cuenta",
    "signOut": "Cerrar sesión",
    "title": {
      "signIn": "Bienvenido de nuevo",
      "signUp": "Crea tu cuenta"
    },
    "email": "Correo",
    "password": "Contraseña",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "resetSent": "Correo de restablecimiento enviado — revisa tu bandeja.",
    "enterEmailFirst": "Ingresa tu correo primero.",
    "noAccount": "¿No tienes cuenta? Crea una",
    "haveAccount": "¿Ya tienes cuenta? Inicia sesión",
    "criteria": {
      "minLength": "Al menos 8 caracteres",
      "uppercase": "Una letra mayúscula",
      "lowercase": "Una letra minúscula",
      "numeric": "Un número",
      "special": "Un carácter especial"
    },
    "errors": {
      "invalid-email": "Ese correo parece inválido.",
      "invalid-credential": "Correo o contraseña incorrectos.",
      "user-not-found": "No se encontró una cuenta con ese correo.",
      "wrong-password": "Correo o contraseña incorrectos.",
      "email-already-in-use": "Ya existe una cuenta con ese correo.",
      "weak-password": "Esa contraseña no cumple los requisitos.",
      "requires-recent-login": "Inicia sesión de nuevo para continuar.",
      "too-many-requests": "Demasiados intentos. Inténtalo más tarde.",
      "network": "Error de red. Verifica tu conexión.",
      "not-configured": "El inicio de sesión no está disponible ahora.",
      "unknown": "Algo salió mal. Inténtalo de nuevo."
    },
    "continueGoogle": "Continuar con Google",
    "continueApple": "Continuar con Apple",
    "or": "o",
    "loggedInAnonymous": "Sesión anónima",
    "continueAnonymous": "Continuar como anónimo",
    "loggedOutWarning": "No has iniciado sesión — tus datos solo están en este dispositivo y podrían perderse."
  },
  "profile": {
    "title": "Perfil",
    "signInRegister": "Iniciar sesión / Registrarse",
    "more": "Más"
  },
  "applyBrowser": {
    "title": "Postular"
  }
}
